import { render, staticRenderFns } from "./NewSlipForm.vue?vue&type=template&id=25405a4c&scoped=true"
import script from "./NewSlipForm.vue?vue&type=script&lang=js"
export * from "./NewSlipForm.vue?vue&type=script&lang=js"
import style0 from "./NewSlipForm.vue?vue&type=style&index=0&id=25405a4c&prod&scoped=true&lang=css"
import style1 from "./NewSlipForm.vue?vue&type=style&index=1&id=25405a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25405a4c",
  null
  
)

export default component.exports